import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { RegisterForm } from '@old/features/public/register/register-form';

export function EdpRegisterPage() {
  return (
    <AuthLayoutComponent variant="edp">
      <RegisterForm referralSource="edp" />
    </AuthLayoutComponent>
  );
}
